import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=b97c8e78&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=b97c8e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97c8e78",
  null
  
)

export default component.exports